const messages = {
  error: "Произошла ошибка. Попробуйте позже.",
  noData: "Данные за указанный период не получены."
}

export default messages